import { InputText } from 'primereact/inputtext';

import styles from './Filters.module.scss';
import { IFiltersProps } from './IFiltersProps';
import AddCountry from '../add/AddCountry';

const Filters = ({
  setCountryCodeFilter,
  setCountryDescriptionFilter,
  setShouldReload,
}: IFiltersProps): JSX.Element => {
  return (
    <div className={styles.container}>
      <InputText
        className={styles.filter}
        placeholder="Country code"
        onChange={e => {
          setCountryCodeFilter(e.target.value);
        }}
      />
      <InputText
        className={styles.filter}
        placeholder="Country description"
        onChange={e => {
          setCountryDescriptionFilter(e.target.value);
        }}
      />

      <AddCountry setShouldReload={setShouldReload} />
    </div>
  );
};

export default Filters;
